<template>
    <div>
        <root-component></root-component>
    </div>
</template>
<script>
import RootComponent from './components/RootComponent'

export default {
    name: 'app-component',
    components: {
        'root-component': RootComponent
    },
    watch:{
        $route (to, from){
            fbq('track', 'PageView');
        }
    },
    mounted() {
      fbq('track', 'PageView');
    },
  created() {
    const onEscape = (e) => {
      if (this.$store.state.videoVisible && e.keyCode === 27) {
         this.$store.state.videoVisible = false
      }
    }
    document.addEventListener('keydown', onEscape)
    this.$once('hook:destroyed', () => {
      document.removeEventListener('keydown', onEscape)
    })
  },
}
</script>
<style lang="scss">
</style>
